import {
    Button,
    Pagination,
    Popconfirm,
    Spin,
    Table,
    Tag,
    Input,
    message,
    Switch,
    Select,
    Flex,
    Popover,
    Form,
    Drawer,
    Card,
    Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, dispatchtoast, messageConfiguration } from "../../../utils";
//   import {
//     updateActivationStatus,
//   } from "./orderapiFunctions";
import { addBrand, addRestro, editBrand, getBrand, getordersDetails, getrestroList, restroDisabled, userRegister } from "../../../ApiServices/Apifun";
import {
    DeleteOutlined,
    EditFilled,
    LoadingOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import errorImage from "../../../assets/images/food.png"
import { ImageUrl } from "../../../ApiServices/Axios";


const RestroList = () => {





    const [orderData, setorderData] = useState([]);
    const [openModal, setOpenModal] = useState(false);

    const [openBrandModal, setOpenBrandModal] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [brandId, setBrandId] = useState(null); // store id if exists

    const [currentStatus, setCurrentStatus] = useState();
    const [loader, setloader] = useState(false);
    const [vendorId, setvendorId] = useState();

    const [form] = Form.useForm();
    const [formbrand] = Form.useForm();
    const handleChangeStatus = (id, status) => {
        setIsLoading(true);
        console.log(status);
        const newStatus = status == 1 ? 0 : 1; // Toggle status

        restroDisabled(`?restaurantId=${id}&isActive=${newStatus}`)
            .then((response) => {
                if (response.status) {
                    message.success("Status updated successfully");
                    setCurrentStatus(newStatus); // Update local state
                    FetchordersDetails();
                } else {
                    message.error("Failed to update status");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error updating status:", err);
                message.error("An error occurred while updating the status");
                setIsLoading(false);
            });
    };

    const popoverContent = (id, status) => (
        <div>
            <p>Are you sure you want to change the status?</p>
            <Button
                type="primary"
                onClick={() => handleChangeStatus(id, status)}
                disabled={isLoading}
            >
                {isLoading ? <Spin size="small" /> : "Confirm"}
            </Button>
        </div>
    );

    const [isLoading, setIsLoading] = useState(false);
    const [addloader, setaddloader] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [action, setAction] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const { Search } = Input;
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const from = location.state?.from;


    const handleFinish = (val) => {
        // Prepare the payload as a JSON object
        const payload = {
            mobile_number: val.mobile_number,
            email: val.email,
            name: val.name,
            password: val.password,
        };
        setaddloader(true);
        // Call the API with JSON data
        addRestro({
            "mobile_number": val.mobile_number,
            "email": val.email,
            "name": val.name,
            "address": val.address,
            "password": val.password,
            "commissionAmount": val.commissionAmount
        })
            .then((res) => {
                if (res.status) {
                    dispatchtoast(res.message); // Display success message
                    setaddloader(false)
                    setOpenModal(false);
                    FetchordersDetails();
                    form.resetFields()
                }
                else {
                    setaddloader(true)
                }
            })
            .catch((err) => {
                console.error(err); message.error(err.response.data.message);
                setaddloader(false)
            }); // Handle error
    };


    const FetchBrandDetails = (vendorId) => {
        setIsLoading(true);
        getBrand(`${vendorId}`)
            .then((response) => {
                if (response.status && response.data) {
                    const brandData = response.data;

                    // Auto-fill form fields
                    formbrand.setFieldsValue({
                        title: brandData.title,
                        theme_color: brandData.theme_color,
                        text_color: brandData.text_color,
                        bg_color1: brandData.bg_color1,
                        bg_color2: brandData.bg_color2,

                        email: brandData.email,
                        mobile_number: brandData.mobile_number,
                        name: brandData.name,
                    });

                    // Save ID for update
                    setBrandId(brandData.id || null);

                    // If logo exists
                    if (brandData.logo_image) {
                        setLogoFile({
                            uid: "-1",
                            name: "logo.png",
                            status: "done",
                            url: ImageUrl + brandData.logo_image,
                        });
                    }
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
            });
    };

    // 🔹 Handle Add/Update
    const handleAddBrand = (val) => {
        const formData = new FormData();

        if (!logoFile) {
            message.error("Please upload a logo");
            return;
        }


        // append normal fields
        formData.append("title", val.title);
        formData.append("theme_color", val.theme_color);
        formData.append("restaurantId", vendorId);

        // append logo if exists
        if (logoFile && logoFile instanceof File) {
            formData.append("logo_image", logoFile);
        }

        setaddloader(true);

        const apiCall = brandId
            ? editBrand(formData, brandId) // update
            : addBrand(formData);          // create

        apiCall
            .then((res) => {
                if (res.status) {
                    dispatchtoast(res.message);
                    setaddloader(false);
                    setOpenBrandModal(false);
                    FetchordersDetails();
                } else {
                    setaddloader(false);
                }
            })
            .catch((err) => {
                console.error(err);
                setaddloader(false);
            });
    };



    // 🔹 Upload config
    const uploadProps = {
        beforeUpload: (file) => {
            const isImage = file.type.startsWith("image/");
            if (!isImage) {
                message.error("Only image files allowed!");
                return Upload.LIST_IGNORE;
            }
            setLogoFile(file);
            return false;
        },
        fileList: logoFile ? [logoFile] : [],
        onRemove: () => setLogoFile(null),
        listType: "picture-card",
    };



    const FetchordersDetails = (page) => {
        setIsLoading(true);
        getrestroList(`?page=${page}&limit=5&search=${searchTerm}`)
            .then((response) => {
                if (response.status) {
                    setorderData(Array.isArray(response.data) ? response.data : []);
                    setCurrentPage(response.pagination.currentPage || 1);
                    setTotalPages(response.pagination.totalPages || 0);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching order details:", err);
                setIsLoading(false);
            });
    };



    const handlePageChange = (page) => {
        setCurrentPage(page); // Update state to trigger useEffect
    };

    // function changeActiveStatus(checked, record) {
    //   console.log(checked, record);
    //   const isDeleteAction = checked === undefined;

    //   let payload = {
    //     name: record.name,
    //     is_active: isDeleteAction ? (checked ? "1" : "0") : record.is_active,
    //     is_deleted: isDeleteAction ? "0" : "1",
    //   };

    //   updateActivationStatus(payload, record.id)
    //     .then((response) => {
    //       if (response.data.status === "success") {
    //         const updatedorderTable = orderData.map((item) =>
    //           item.id === record.id
    //             ? {
    //               ...item,
    //               is_active: isDeleteAction
    //                 ? item.is_active
    //                 : payload.is_active,
    //             }
    //             : item
    //         );
    //         setorderData(updatedorderTable);
    //         FetchordersDetails(currentPage);
    //         message.open(
    //           messageConfiguration(
    //             "success",
    //             isDeleteAction
    //               ? "Category deleted successfully."
    //               : response.message,
    //             3
    //           )
    //         );
    //         if (!isDeleteAction) {
    //           FetchordersDetails(currentPage);
    //         }
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       message.open(
    //         messageConfiguration(
    //           "error",
    //           isDeleteAction
    //             ? "Failed to delete category."
    //             : "Failed to update status.",
    //           3
    //         )
    //       );
    //     });

    // }

    const handleErrorImage = (e) => {

        e.target.src = errorImage

    }
    // console.log("tottaaaaaaaaaaal", totalPage);
    const setwithdrawAction = (id, value) => {
        setAction((prevAction) => ({
            ...prevAction,
            [id]: value,
        }));
    };

    useEffect(() => {
        FetchordersDetails(currentPage);
    }, [currentPage, searchTerm]);

    const handleDrawerClose = () => {
        setOpenModal(false);
    };

    const handleBrandDrawerClose = () => {
        setOpenBrandModal(false);
    };



    const columns = [
        // {
        //     title: "Image",
        //     dataIndex: "imageUrl",
        //     key: "imageUrl",
        //     className: "custom-header",
        //     render: (text) => {
        //         return (
        //             <>
        //                 <p className="font-medium w-[120px]">
        //                     <img src={text} onError={handleErrorImage} crossOrigin="anonymous" />
        //                 </p>
        //             </>
        //         );
        //     },
        // },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            className: "custom-header ",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            className: "custom-header whitespace-nowrap",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Phone no.",
            dataIndex: "mobile_number",
            key: "mobile_number",
            className: "custom-header",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Created Time",
            dataIndex: "register_date",
            key: "register_date",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs">
                            {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "is_active",
            key: "is_active",
            className: "custom-header",
            render: (_, record) => (
                <Popover
                    content={popoverContent(record.id, record.is_active)}
                    trigger="click"
                    placement="bottom"
                >
                    <Tag
                        style={{
                            fontWeight: "bold",
                            color: record.is_active == 1 ? "green" : "red",
                            backgroundColor: record.is_active == 1 ? "#e0f5f0" : "#FFE1E1",
                            borderColor: record.is_active == 1 ? "lightgreen" : "pink",
                            borderRadius: "0px",
                            cursor: "pointer",
                        }}
                    >
                        {record.is_active == 1 ? "Active" : "Inactive"}
                    </Tag>
                </Popover>
            ),
        },
        {
            title: "Add Brand",
            dataIndex: "is_active",
            key: "is_active",
            className: "custom-header",
            render: (_, record) => (
                <EditFilled onClick={() => { FetchBrandDetails(record.id); setLogoFile(null); formbrand.resetFields(); setBrandId(null); setvendorId(record.id); setOpenBrandModal(true) }} />
            ),
        },
    ];



    return (
        <div className="p-4">
            <div className="flex items-end justify-end m-2">
                <Search
                    placeholder="search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "26%" }}
                />
            </div>
            <Card
                title="Restro List"
                // extra={
                //     <Button
                //         type="primary"
                //         icon={<PlusOutlined />}
                //         onClick={() => console.log("Add Order")}
                //         className="rounded"
                //     >
                //         Add Restro
                //     </Button>
                // }
                className="shadow-sm shadow-gray-300"
            >
                <Table
                    title={() => (
                        <div className="flex gap-2 justify-end">
                            <Button onClick={() => setOpenModal(true)} className="bg-rgbaprimary8 text-white font-semibold rounded-none h-10">
                                {" "}
                                <PlusOutlined /> Add Restro
                            </Button>

                        </div>
                    )}
                    bordered={true}
                    loading={isLoading}
                    columns={columns}
                    dataSource={orderData}
                    pagination={false}
                    className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
                    size="small"
                />
            </Card>
            <Pagination
                className="mt-2 text-xs w-full flex justify-end"
                total={totalPages * 10} // Assuming 10 items per page
                showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${totalPages * 10} items`
                }
                onChange={handlePageChange}
                defaultPageSize={10}
                current={currentPage}
            />
            <Drawer
                title="Add Restro"
                width={400}
                onClose={handleDrawerClose}
                visible={openModal}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleFinish}
                // initialValues={profile}
                >
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: "Please enter Restro name" }]}
                    >
                        <Input placeholder="Enter Restro name" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: "Please enter your email" },
                            { type: "email", message: "Please enter a valid email" },
                        ]}
                    >
                        <Input placeholder="Enter your email" />
                    </Form.Item>
                    <Form.Item
                        name="mobile_number"
                        label="Mobile Number"
                        rules={[
                            {
                                required: true,
                                message: "Please enter your mobile number",
                            },
                            {
                                pattern: /^[6-9]\d{9}$/,
                                message: "mobile number is invalid",
                            },
                        ]}
                    >
                        <Input placeholder="Enter your mobile number" />
                    </Form.Item>
                    <Form.Item
                        name="commissionAmount"
                        label="Commission Amount"
                        rules={[
                            {
                                required: true,
                                message: "Please enter your commission Amount",

                            },
                            {
                                pattern: /^(100|[1-9]?[0-9])$/,
                                message: "commission amount is in percent",
                            },

                        ]}
                    >
                        <Input placeholder="Enter your commission Amount in %" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[
                            {
                                required: true,
                                message: "Please enter your Password",
                            },
                        ]}
                    >
                        <Input placeholder="Enter your Password" />
                    </Form.Item>
                    <Form.Item name="address" label="Address" rules={[
                        {
                            required: true,
                            message: "Please enter your Address",
                        },
                    ]}>
                        <Input placeholder="Enter your Address" />
                    </Form.Item>

                    <Button loading={addloader} type="primary" htmlType="submit" block>
                        Add Restro
                    </Button>
                </Form>
            </Drawer>
            <Drawer
                title="Add Brand"
                width={400}
                onClose={handleBrandDrawerClose}
                visible={openBrandModal}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form layout="vertical" form={formbrand} onFinish={handleAddBrand}>
                    <Form.Item
                        name="title"
                        label="Title"
                        rules={[{ required: true, message: "Please enter Restro title" }]}
                    >
                        <Input placeholder="Enter Restro title" />
                    </Form.Item>

                    <Form.Item
                        name="theme_color"
                        label="Theme color"
                        rules={[
                            { required: true, message: "Please select your theme color" },
                        ]}
                    >
                        <Input
                            type="color"
                            style={{
                                width: "100%",
                                height: "40px",
                                padding: "0",
                                border: "1px solid #d9d9d9",
                                borderRadius: "6px",
                                cursor: "pointer",
                            }}
                            onChange={(e) => formbrand.setFieldsValue({ theme_color: e.target.value })}
                        />
                    </Form.Item>

                    <Form.Item
                        name="text_color"
                        label="Text color"
                        rules={[
                            { required: true, message: "Please select your text color" },
                        ]}
                    >
                        <Input
                            type="color"
                            style={{
                                width: "100%",
                                height: "40px",
                                padding: "0",
                                border: "1px solid #d9d9d9",
                                borderRadius: "6px",
                                cursor: "pointer",
                            }}
                            onChange={(e) => formbrand.setFieldsValue({ text_color: e.target.value })}
                        />
                    </Form.Item>

                    <Form.Item
                        name="bg_color1"
                        label="Main Background color"
                        rules={[
                            { required: true, message: "Please select your color" },
                        ]}
                    >
                        <Input
                            type="color"
                            style={{
                                width: "100%",
                                height: "40px",
                                padding: "0",
                                border: "1px solid #d9d9d9",
                                borderRadius: "6px",
                                cursor: "pointer",
                            }}
                            onChange={(e) => formbrand.setFieldsValue({ bg_color1: e.target.value })}
                        />
                    </Form.Item>

                    <Form.Item
                        name="bg_color2"
                        label="Secondery Background color"
                        rules={[
                            { required: true, message: "Please select your color" },
                        ]}
                    >
                        <Input
                            type="color"
                            style={{
                                width: "100%",
                                height: "40px",
                                padding: "0",
                                border: "1px solid #d9d9d9",
                                borderRadius: "6px",
                                cursor: "pointer",
                            }}
                            onChange={(e) => formbrand.setFieldsValue({ bg_color2: e.target.value })}
                        />
                    </Form.Item>


                    {/* Upload Logo */}
                    <Form.Item label="Brand Logo" required>
                        <Upload {...uploadProps}>
                            {!logoFile && (
                                <div>
                                    <PlusOutlined />
                                    <div style={{ marginTop: 8 }}>Upload</div>
                                </div>
                            )}
                        </Upload>
                    </Form.Item>


                    <Button loading={addloader} type="primary" htmlType="submit" block>
                        {brandId ? 'Edit' : "Add"} Brand
                    </Button>
                </Form>
            </Drawer>
        </div>

    );
};
export default RestroList;
